import { useEffect, useMemo, useState } from 'react';
import Selector from '../../components/forms/Selector';
import IconSave from '../../components/icons/IconSave';
import IconDelete from '../../components/icons/IconDelete';
import language from '../../variables/language';

const resolveValue = (val) => {
   if(val && typeof val === 'object' && val.id !== undefined) {
      return String(val.id);
   }
   if(val === null || val === undefined) {
      return '';
   }
   return String(val);
}

const flattenTemplate = (template) => ({
   name: resolveValue(template.name),
   description: resolveValue(template.description),
   level: resolveValue(template.level),
   classification: resolveValue(template.classification),
   type: resolveValue(template.type),
});

// Dirty-tracking is a DERIVED comparison (formValues vs. a separately-held
// initialValues snapshot), not an imperative isDirty flag flipped on every
// onChange - Selector.jsx echoes the already-selected value back through
// selectorsHundler once on mount, which would otherwise mark the form dirty
// before the user has touched anything. Mirrors LessonDetailModal.jsx.
export default function BuilderHeader({ template, onSave, onDelete }) {
   const [formValues, setFormValues] = useState(null);
   const [initialValues, setInitialValues] = useState(null);
   const [saving, setSaving] = useState(false);
   const lang = language[language.lang];

   useEffect(() => {
      if(!template) return;
      const flat = flattenTemplate(template);
      setFormValues(flat);
      setInitialValues(flat);
   }, [template]);

   const isDirty = useMemo(() => {
      if(!formValues || !initialValues) return false;
      return JSON.stringify(formValues) !== JSON.stringify(initialValues);
   }, [formValues, initialValues]);

   if(!template || !formValues) return '';

   const handleFieldChange = (name, value) => {
      setFormValues(prev => ({...prev, [name]: value}));
   }

   const handleSave = () => {
      if(!isDirty || saving) return;
      setSaving(true);
      onSave(formValues).then(() => {
         setInitialValues(formValues);
      }).catch(err => console.error(err)).finally(() => setSaving(false));
   }

   return (
      <div className='exercise-builder-header'>
         <div className='exercise-builder-header-top'>
            <input className='exercise-builder-name-input' value={formValues.name}
               placeholder={lang.name} onChange={e => handleFieldChange('name', e.target.value)} />
            <div className='exercise-builder-header-actions'>
               {isDirty ? (
                  <div className='exercise-builder-save-btn' onClick={handleSave} title={lang.save}>
                     <IconSave fillColor='icon-green' style={{height:28, width:28}} />
                  </div>
               ) : ''}
               <div className='exercise-builder-delete-btn' onClick={onDelete} title='Видалити шаблон'>
                  <IconDelete style={{fill:'#e0876c', width:16, height:16, margin:0}} />
               </div>
            </div>
         </div>
         <textarea className='exercise-builder-description-input' rows={2}
            placeholder={lang.description} value={formValues.description}
            onChange={e => handleFieldChange('description', e.target.value)} />
         <div className='exercise-builder-meta-row'>
            <div className='flex-from-input-wraper exercise-builder-meta-field' data-label={lang.level}>
               <Selector className='submit-field form-selection txt-c'
                  name='level' url='/api/levels' value={formValues.level}
                  selectorsHundler={(value) => handleFieldChange('level', value)} />
            </div>
            <div className='flex-from-input-wraper exercise-builder-meta-field' data-label={lang.clasification}>
               <Selector className='submit-field form-selection txt-c'
                  name='classification' url='/api/exerciseclassifications' value={formValues.classification}
                  selectorsHundler={(value) => handleFieldChange('classification', value)} />
            </div>
            <div className='flex-from-input-wraper exercise-builder-meta-field' data-label={lang.type}>
               <Selector className='submit-field form-selection txt-c'
                  name='type' url='/api/exercisetypes' value={formValues.type}
                  selectorsHundler={(value) => handleFieldChange('type', value)} />
            </div>
         </div>
      </div>
   );
}
